import { render, staticRenderFns } from "./NuevoTipoTurno.vue?vue&type=template&id=6450c942&scoped=true"
import script from "./NuevoTipoTurno.vue?vue&type=script&lang=js"
export * from "./NuevoTipoTurno.vue?vue&type=script&lang=js"
import style0 from "./NuevoTipoTurno.vue?vue&type=style&index=0&id=6450c942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450c942",
  null
  
)

export default component.exports